const state = {
  tab_type: 3,
  is_show: false,
  scroll0: 0,
  scroll1: 0,
  scroll2: 0,
  scroll3: 0,
  comment_num: 0,
  praised: -1,
  fromid: -1,
};
const mutations = {
  tabType(state, tabType) {
    state.tab_type = tabType;
  },
  is_show(state, is_show) {
    state.is_show = is_show;
  },
  scroll0(state, scroll0) {
    state.scroll0 = scroll0;
  },
  scroll1(state, scroll1) {
    state.scroll1 = scroll1;
  },
  scroll2(state, scroll2) {
    state.scroll2 = scroll2;
  },
  scroll3(state, scroll3) {
    state.scroll3 = scroll3;
  },
  comment_num(state, comment_num) {
    state.comment_num = comment_num;
  },
  praised(state, praised) {
    state.praised = praised;
  },
  fromid(state, fromid) {
    state.fromid = fromid;
  },
};
const actions = {
  tabType: ({ commit }) => commit("tabType"),
  is_show: ({ commit }) => commit("is_show"),
  scroll0: ({ commit }) => commit("scroll0"),
  scroll1: ({ commit }) => commit("scroll1"),
  scroll2: ({ commit }) => commit("scroll2"),
  scroll3: ({ commit }) => commit("scroll3"),
  comment_num: ({ commit }) => commit("comment_num"),
  praised: ({ commit }) => commit("praised"),
  fromid: ({ commit }) => commit("fromid"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
